import { Fragment } from 'react';
import Button from '@monofront/design-system/components/Button';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { ICtaImageMultipleText, IItem } from './types';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@components/CustomPrismicLink';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapCtaImageMultipleText } from './mapCtaImageMultipleText';

const CtaImageMultipleText: React.FC<ICtaImageMultipleText> = ({
  alt,
  buttonLabel,
  image,
  items,
  link,
  title,
}) => {
  return (
    <div className="manifest">
      <div className="root">
        <div className="manifest-img">
          <ResponsiveImage
            src={image}
            alt={alt}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className="manifest-text">
          <div className="title">
            <RichText render={title} />
          </div>
          {items.map((item: IItem, index: number) => {
            return item.whiteBackground ? (
              <div className="text-important" key={index}>
                <RichText render={item.title} />
                <div className="text">
                  <RichText
                    render={item.text}
                    serializeHyperlink={CustomPrismicLink}
                  />
                </div>
              </div>
            ) : (
              <Fragment key={index}>
                <RichText render={item.title} />
                <div className="text">
                  <RichText
                    render={item.text}
                    serializeHyperlink={CustomPrismicLink}
                  />
                </div>
              </Fragment>
            );
          })}
          <div className="cta">
            <a href={link}>
              <Button block={false}>{buttonLabel}</Button>
            </a>
          </div>
        </div>
      </div>
      <style jsx>{`
        .root {
          display: flex;
          flex-direction: row;
        }

        .manifest-img {
          flex: 0 1 34%;
          height: 700px;
          width: 350px;
          position: relative;
        }

        .manifest-img > :global(img) {
          transform: scale(-1, 1);
        }

        .manifest-text {
          flex: 0 1 66%;
        }

        .manifest-text :global(div) {
          height: fit-content;
        }

        .title {
          display: flex;
          align-items: center;
          padding-left: 10%;
          margin-bottom: var(--space-4);
        }

        .manifest-text > h1 > :global(span) {
          transform: scale(-1, -1);
        }

        .manifest-text > :global(h2),
        .text-important > :global(h2) {
          padding-left: 10%;
          margin-bottom: 10px;
        }

        .text {
          padding-left: 10%;
          margin-bottom: 24px;
        }

        .text-important {
          padding: 27px 0%;
        }

        .text-important > .text {
          margin-bottom: 0;
        }

        .cta {
          margin: 24px 0 8px 10%;
        }

        @media (max-width: 800px) {
          .manifest-img {
            display: none;
          }

          .manifest-text {
            flex: 1;
          }

          .title {
            padding-left: 0;
            justify-content: center;
          }

          .manifest-text > :global(h2),
          .text-important > :global(h2) {
            padding: var(--padding-layout-sm);
          }

          .text {
            padding: var(--padding-layout-sm);
          }

          .cta {
            padding: var(--padding-layout-sm);
            margin: 24px 0 8px 0;
            display: flex;
            justify-content: space-around;
          }

          .cta > :global(button) {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default withSlice(CtaImageMultipleText, mapCtaImageMultipleText);
